import { useState, useEffect } from 'react';
import { Tooltip, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { MdEvStation } from 'react-icons/md';

const HEALTH_CHECK_INTERVAL_MS = 60000;

const OCPPHealthCheck = () => {
  const [status, setStatus] = useState('loading');
  const [lastCheckedAt, setLastCheckedAt] = useState(null);

  const checkHealth = async () => {
    try {
      const url = import.meta.env.VITE_OCPP_HEALTH_CHECK_URL;
      if (!url) {
        setStatus('unhealthy');
        setLastCheckedAt(new Date());
        return;
      }
      const response = await axios.get(url, { timeout: 10000 });
      setStatus(response.status === 200 ? 'healthy' : 'unhealthy');
    } catch (error) {
      console.error('OCPP health check error:', error);
      setStatus('unhealthy');
    } finally {
      setLastCheckedAt(new Date());
    }
  };

  useEffect(() => {
    checkHealth();
    const interval = setInterval(checkHealth, HEALTH_CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const isLoading = status === 'loading';
  const isHealthy = status === 'healthy';

  const tooltipTitle = isLoading
    ? 'Checking OCPP server status...'
    : `${isHealthy ? 'OCPP Server Online' : 'OCPP Server Offline'}${
        lastCheckedAt
          ? ` · Last checked ${lastCheckedAt.toLocaleTimeString()}`
          : ''
      }`;

  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <div
        onClick={checkHealth}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') checkHealth();
        }}
        aria-label={tooltipTitle}
        className="flex items-center justify-center cursor-pointer select-none"
        style={{ height: 32 }}
      >
        {isLoading ? (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />} />
        ) : (
          <span
            aria-hidden="true"
            className="inline-flex items-center justify-center rounded-full"
            style={{
              width: 34,
              height: 34,
              border: `1px solid ${isHealthy ? '#16a34a' : '#dc2626'}`,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdEvStation size={18} color={isHealthy ? '#16a34a' : '#dc2626'} />
          </span>
        )}
      </div>
    </Tooltip>
  );
};

export default OCPPHealthCheck;
